const $ = require('jquery')

function openResponsiveHeader()
{
	var trigger = $(".js-openResponsiveHeader");
	trigger.click(function () {
		var $header = $("#js-header");
		if (!$header.hasClass("is-open")) {
            $header.addClass("is-open");
		} else {
            $header.removeClass("is-open");
		}
	});
}

openResponsiveHeader();
